<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Penafian</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-4 mx-1 mx-md-3">
        <div class="col-12 text-left my-2 px-0 px-md-4">
          <p>
            Kerajaan Malaysia dan Radio Televisyen Malaysia adalah tidak
            bertanggungjawab atas kehilangan atau kerugian yang disebabkan oleh
            penggunaan mana-mana maklumat yang diperolehi dari laman web ini
            serta tidak boleh ditafsirkan sebagai agen kepada, ataupun syarikat
            yang disyorkan oleh RTM
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 20px 0 0;
  min-height: 80vh;
}

h1 {
  font-family: Inter;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
p {
  font-family: Inter;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #fff;
}
</style>
